import { __decorate, __param } from 'tslib';
import { EventEmitter, Inject, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DateHelper, StringHelper, DateConstant } from '@colibrium/abp-base';

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AbpCalendarComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "h3");
    ɵngcc0.ɵɵelementStart(2, "button", 13);
    ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_div_10_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onPrevMonthClick(); });
    ɵngcc0.ɵɵtext(3, " < ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 14);
    ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_div_10_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onDisplayHeaderClick(1); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 15);
    ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_div_10_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onNextMonthClick(); });
    ɵngcc0.ɵɵtext(7, " > ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("disabled", ctx_r0.calendarModel.isPrevYearBtnDisabled ? "true" : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.calendarModel.displayMonthVal.monthName, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("disabled", ctx_r0.calendarModel.isNextYearBtnDisabled ? "true" : null);
} }
function AbpCalendarComponent_thead_13_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "th", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const name_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "t_abp_calendar_grid_header_cell_", i_r9, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", name_r8, " ");
} }
function AbpCalendarComponent_thead_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "thead", 16);
    ɵngcc0.ɵɵelementStart(1, "tr", 17);
    ɵngcc0.ɵɵtemplate(2, AbpCalendarComponent_thead_13_ng_container_2_Template, 3, 2, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.calendarModel.weekNames);
} }
const _c0 = function (a0, a1) { return { "monthyear-cell": a0, "weekday-data-cell": a1 }; };
const _c1 = function (a0, a1, a2) { return { "current-datepart": a0, "other-month-date": a1, "selected-datepart": a2 }; };
function AbpCalendarComponent_ng_container_15_tr_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "td", 21);
    ɵngcc0.ɵɵelementStart(2, "button", 22);
    ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_ng_container_15_tr_1_ng_container_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const item_r14 = ctx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.onGridCellClick(item_r14); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const j_r15 = ctx.index;
    const i_r12 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "t_abp_calendar_grid_body_cell_", i_r12, "_", j_r15, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c0, !ctx_r13.canShowSection(0), ctx_r13.canShowSection(0)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(8, _c1, item_r14.isCurrentPart, item_r14.isDisabled, item_r14.isSelectedDatePart));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14.displayText, " ");
} }
const _c2 = function (a0, a1) { return { "monthyear-row": a0, "weekday-row": a1 }; };
function AbpCalendarComponent_ng_container_15_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 21);
    ɵngcc0.ɵɵtemplate(1, AbpCalendarComponent_ng_container_15_tr_1_ng_container_1_Template, 4, 12, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const itemArr_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "t_abp_calendar_grid_body_row_", i_r12, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c2, !ctx_r10.canShowSection(0), ctx_r10.canShowSection(0)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", itemArr_r11);
} }
function AbpCalendarComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AbpCalendarComponent_ng_container_15_tr_1_Template, 2, 6, "tr", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.calendarModel.displayGrid.gridData);
} }
class AbpCalendarConstant {
}
AbpCalendarConstant.calendarConfigInjectKey = 'calendar-config';

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpCalendarConfigModel {
    //#endregion model properties
    //#region constructor
    constructor() {
        //#region model properties
        this.weekDisplayNames = [];
        this.monthDisplayNames = [];
        this.weekDisplayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        this.monthDisplayNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    }
}

//#region angular imports
//#endregion angular imports
//#endregion functional/model imports
class CalendarGridModel {
    //#endregion model properties
    //#region constructor
    constructor() {
        this.gridData = [];
    }
}

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class CalendarDateModel {
    get day() {
        if (this.dateValue) {
            return this.dateValue.getDate();
        }
        return null;
    }
    //public get month(): CalendarMonthModel {
    //  let model = new CalendarMonthModel;
    //  if (this.dateValue) {
    //    model.monthIndex = this.dateValue.getMonth();
    //    model.monthName = DateHelper.getMonthCode(model.monthIndex + 1);
    //    return model;
    //  }
    //  return model;
    //}
    //public get year(): number | null {
    //  if (this.dateValue) {
    //    return this.dateValue.getFullYear();
    //  }
    //  return null;
    //}
    //public get isTodayDate(): boolean {
    //  if (this.dateValue && DateHelper.isCurrentDate(this.dateValue)) {
    //    return true;
    //  }
    //  return false;
    //}
    //#endregion model properties
    //#region constructor
    constructor() {
    }
}

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class CalendarMonthModel {
    /** is current/today date month */
    get isTodayMonth() {
        return (this.monthIndex == new Date().getMonth());
    }
}

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class CalendarYearModel {
    /** is current/today date month */
    get isCurrent() {
        return (this.year == new Date().getFullYear());
    }
}

var CalendarDisplay;
(function (CalendarDisplay) {
    CalendarDisplay[CalendarDisplay["days"] = 0] = "days";
    CalendarDisplay[CalendarDisplay["months"] = 1] = "months";
    CalendarDisplay[CalendarDisplay["years"] = 2] = "years";
})(CalendarDisplay || (CalendarDisplay = {}));

//#region angular imports
//#endregion functional/model imports
class CalendarModel {
    //#endregion model properties
    //#region constructor
    constructor() {
        //#region model properties
        /** todays date value */
        this.currentDate = new Date();
        /** week header names to display */
        this.weekNames = [];
        /** month header names to display */
        this.monthNames = [];
        /** enum value to indicate display section of calendar grid */
        this.calendarDisplay = CalendarDisplay.days;
        this.displayDateVal = new CalendarDateModel();
        this.displayMonthVal = new CalendarMonthModel();
        this.displayYearVal = new CalendarYearModel();
        this.weekDaysGrid = new CalendarGridModel();
        this.monthsGrid = new CalendarGridModel();
        this.yearsGrid = new CalendarGridModel();
    }
    get isPrevMonthBtnDisabled() {
        if (this.displayMonthVal.monthIndex == 0) {
            return true;
        }
        return false;
    }
    get isNextMonthBtnDisabled() {
        if (this.displayMonthVal.monthIndex == 11) {
            return true;
        }
        return false;
    }
    get isPrevYearBtnDisabled() {
        if (this.displayYearVal.year == this.currentDate.getFullYear() - 100) {
            return true;
        }
        return false;
    }
    get isNextYearBtnDisabled() {
        if (this.displayYearVal.year == this.currentDate.getFullYear() + 100) {
            return true;
        }
        return false;
    }
    /** gets grid data for display */
    get displayGrid() {
        switch (this.calendarDisplay) {
            case CalendarDisplay.days:
                return this.weekDaysGrid;
            case CalendarDisplay.months:
                return this.monthsGrid;
            case CalendarDisplay.years:
                return this.yearsGrid;
            default:
                return this.weekDaysGrid;
        }
    }
}

//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class CalendarGridCellModel {
    //#endregion model properties
    //#region constructor
    constructor() {
    }
}

//#region angular imports
//#endregion functional/model imports
let AbpCalendarComponent = class AbpCalendarComponent {
    //#endregion model properties
    //#region constructor
    constructor(config) {
        this.config = config;
        this.selectedDateChange = new EventEmitter();
        this.calendarModel = new CalendarModel();
        this.calendarModel.weekNames = config.weekDisplayNames;
        this.calendarModel.monthNames = config.monthDisplayNames;
        this.generateMonthGridData();
    }
    //#endregion constructor
    //#region component events
    ngOnInit() {
        let dateToConsider = this.calendarModel.currentDate;
        if (DateHelper.isValid(this.selectedDate)) {
            dateToConsider = this.selectedDate;
        }
        this.setDisplayDateInfo(dateToConsider);
        this.setDisplayMonthInfo(dateToConsider.getMonth());
        this.setDisplayYearInfo(dateToConsider.getFullYear());
        this.setDefaultsForYearRange();
        this.generateYearGridData(0);
        this.generateWeekDateCalendar();
    }
    //ngOnChanges(changes: SimpleChanges): void {
    //  if (changes.selectedDates &&
    //    changes.selectedDates.currentValue &&
    //    changes.selectedDates.currentValue.length > 1) {
    //    // sort on date changes for better performance when range checking
    //    //changes.selectedDates.currentValue.
    //    //this.sortedDates = _.sortBy(changes.selectedDates.currentValue, (m: CalendarDate) => m.mDate.valueOf());
    //    this.generateCalendar();
    //  }
    //}
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * on display header click handler
     * @param display
     */
    onDisplayHeaderClick(display) {
        this.calendarModel.calendarDisplay = display;
        return true;
    }
    /**
     * determines if a section can be showed
     * @param display
     */
    canShowSection(display) {
        return this.calendarModel.calendarDisplay == display;
    }
    /**
     * on grid cell click
     * @param cellModel
     */
    onGridCellClick(cellModel) {
        switch (this.calendarModel.calendarDisplay) {
            case CalendarDisplay.days:
                this.onWeekDateSelect(cellModel);
                break;
            case CalendarDisplay.months:
                this.onMonthSelect(cellModel);
                break;
            case CalendarDisplay.years:
                this.onYearSelect(cellModel);
                break;
        }
        this.setSelectedStateForAllGrid();
    }
    /**
     * previous month click
     */
    onPrevMonthClick() {
        if (this.calendarModel.displayMonthVal.monthIndex > 0) {
            this.setDisplayMonthInfo(this.calendarModel.displayMonthVal.monthIndex - 1);
            this.generateWeekDateCalendar();
        }
    }
    /**
     * next month click
     */
    onNextMonthClick() {
        if (this.calendarModel.displayMonthVal.monthIndex < 11) {
            this.setDisplayMonthInfo(this.calendarModel.displayMonthVal.monthIndex + 1);
            this.generateWeekDateCalendar();
        }
    }
    /**
     * previous year click
     */
    onPrevYearClick() {
        if (!this.calendarModel.isPrevYearBtnDisabled) {
            if (this.calendarModel.calendarDisplay == CalendarDisplay.years) {
                this.generateYearGridData(-12);
            }
            else {
                this.setDisplayYearInfo(this.calendarModel.displayYearVal.year - 1);
                this.generateWeekDateCalendar();
            }
        }
    }
    /**
     * next year click
     */
    onNextYearClick() {
        if (!this.calendarModel.isNextYearBtnDisabled) {
            if (this.calendarModel.calendarDisplay == CalendarDisplay.years) {
                this.generateYearGridData(12);
            }
            else {
                this.setDisplayYearInfo(this.calendarModel.displayYearVal.year + 1);
                this.generateWeekDateCalendar();
            }
        }
    }
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * sets months for grid
     */
    generateMonthGridData() {
        let months = [];
        let model;
        for (let i = 0; i < this.calendarModel.monthNames.length; i++) {
            model = new CalendarGridCellModel();
            model.displayText = StringHelper.toFirstLetterCapital(this.calendarModel.monthNames[i]);
            model.value = i;
            model.isCurrentPart = (this.calendarModel.currentDate.getMonth() == i);
            model.isDisplayDatePart = (this.calendarModel.displayMonthVal.monthIndex == i);
            if (this.selectedDate && this.selectedDate.getMonth() == i) {
                model.isSelectedDatePart = true;
            }
            model.isDisabled = false;
            months.push(model);
        }
        while (months.length > 0) {
            this.calendarModel.monthsGrid.gridData.push(months.splice(0, 4));
        }
    }
    /**
     * sets years for grid
     * @param count
     */
    generateYearGridData(count) {
        this.calendarModel.minYearRange = this.calendarModel.minYearRange + count;
        this.calendarModel.maxYearRange = this.calendarModel.maxYearRange + count;
        let years = [];
        let yearModel;
        for (let i = this.calendarModel.minYearRange; i <= this.calendarModel.maxYearRange; i++) {
            yearModel = new CalendarGridCellModel();
            yearModel.displayText = i.toString();
            yearModel.value = i;
            yearModel.isCurrentPart = (this.calendarModel.currentDate.getFullYear() == i);
            yearModel.isDisplayDatePart = (this.calendarModel.displayYearVal.year == i);
            if (this.selectedDate && this.selectedDate.getFullYear() == i) {
                yearModel.isSelectedDatePart = true;
            }
            years.push(yearModel);
        }
        this.calendarModel.yearsGrid.gridData = [];
        while (years.length > 0) {
            this.calendarModel.yearsGrid.gridData.push(years.splice(0, 4));
        }
    }
    /**
     * generates week days for grid
     */
    generateWeekDateCalendar() {
        let calendarDates = [];
        let firstDateOfMonth = DateHelper.getFirstDateOfMonth(this.calendarModel.displayDateVal.dateValue);
        //To get first day of grid, we need sunday (index-0) date. Hence subtracting week day index from current date to get 0 based sunday date
        let firstDayOfGrid = DateHelper.subtract(firstDateOfMonth, firstDateOfMonth.getDay(), DateConstant.duration.days);
        //we need 42 days(6 weeks) on the calendar,
        let model;
        for (let i = 0; i < 42; i++) {
            model = new CalendarGridCellModel();
            model.value = DateHelper.add(firstDayOfGrid, i, DateConstant.duration.days);
            model.displayText = model.value.getDate().toString();
            model.isSelectedDatePart = this.isSameMonthAndDate(model.value, this.selectedDate);
            model.isCurrentPart = this.isSameMonthAndDate(model.value, this.calendarModel.currentDate);
            model.isDisplayDatePart = (this.calendarModel.displayDateVal.day == model.value.getDate());
            model.isDisabled = (this.calendarModel.displayMonthVal.monthIndex != model.value.getMonth());
            calendarDates.push(model);
        }
        this.calendarModel.weekDaysGrid.gridData = [];
        while (calendarDates.length > 0) {
            this.calendarModel.weekDaysGrid.gridData.push(calendarDates.splice(0, 7));
        }
    }
    /**
     * sets display date model values
     * @param dateInput
     * @param day
     * @param monthIndex
     * @param yearVal
     */
    setDisplayDateInfo(dateInput, day, monthIndex, yearVal) {
        if (DateHelper.isValid(dateInput)) {
            let date = day != null ? day : dateInput.getDate();
            let month = monthIndex != null ? monthIndex : dateInput.getMonth();
            let year = yearVal != null ? yearVal : dateInput.getFullYear();
            this.calendarModel.displayDateVal.dateValue = new Date(year, month, date);
        }
    }
    /**
     * sets display month model values
     * @param monthIndex
     */
    setDisplayMonthInfo(monthIndex) {
        this.calendarModel.displayMonthVal.monthIndex = monthIndex;
        this.calendarModel.displayMonthVal.monthName = StringHelper.toFirstLetterCapital(this.calendarModel.monthNames[monthIndex]);
        //set date
        this.setDisplayDateInfo(this.calendarModel.displayDateVal.dateValue, null, monthIndex);
    }
    /**
     * sets display year model values
     * @param year
     */
    setDisplayYearInfo(year) {
        this.calendarModel.displayYearVal.year = year;
        //set date
        this.setDisplayDateInfo(this.calendarModel.displayDateVal.dateValue, null, null, year);
    }
    /**
     * determines if both dates have same date and month
     * @param actualDate
     * @param inputDate
     */
    isSameMonthAndDate(actualDate, inputDate) {
        if (DateHelper.isValid(actualDate) &&
            DateHelper.isValid(inputDate) &&
            DateHelper.isSameDatePart(actualDate, inputDate, DateConstant.duration.days) &&
            DateHelper.isSameDatePart(actualDate, inputDate, DateConstant.duration.months)) {
            return true;
        }
        return false;
    }
    /**
     * sets default values
     */
    setDefaultsForYearRange() {
        //at a time display 12 years - -6, input year ,+5
        this.calendarModel.minYearRange = this.calendarModel.displayYearVal.year - 6;
        this.calendarModel.maxYearRange = this.calendarModel.displayYearVal.year + 5;
    }
    /**
     * sets selected status
     */
    setSelectedStateForAllGrid() {
        this.calendarModel.weekDaysGrid.gridData.forEach((row) => {
            row.forEach((col) => {
                col.isSelectedDatePart = this.isSameMonthAndDate(col.value, this.selectedDate);
            });
        });
        this.calendarModel.monthsGrid.gridData.forEach((row) => {
            row.forEach((col) => {
                if (DateHelper.isValid(this.selectedDate)) {
                    col.isSelectedDatePart = (this.selectedDate.getMonth() == col.value);
                }
            });
        });
        this.calendarModel.yearsGrid.gridData.forEach((row) => {
            row.forEach((col) => {
                if (DateHelper.isValid(this.selectedDate)) {
                    col.isSelectedDatePart = (this.selectedDate.getFullYear() == col.value);
                }
            });
        });
    }
    /**
     * on weed day cell click handler
     * @param cellModel
     */
    onWeekDateSelect(cellModel) {
        this.selectedDate = cellModel.value;
        this.selectedDateChange.emit(this.selectedDate);
        this.setDisplayDateInfo(this.selectedDate);
    }
    /**
     * on month cell click handler
     * @param cellModel
     */
    onMonthSelect(cellModel) {
        this.setDisplayMonthInfo(cellModel.value);
        if (DateHelper.isValid(this.selectedDate)) {
            //set selected date with month
            this.selectedDate = new Date(this.selectedDate.getFullYear(), this.calendarModel.displayMonthVal.monthIndex, this.selectedDate.getDate());
        }
        this.generateWeekDateCalendar();
        this.calendarModel.calendarDisplay = CalendarDisplay.days;
    }
    /**
     * on year cell click handler
     * @param cellModel
     */
    onYearSelect(cellModel) {
        this.setDisplayYearInfo(cellModel.value);
        if (DateHelper.isValid(this.selectedDate)) {
            //set selected date with month
            this.selectedDate = new Date(this.calendarModel.displayYearVal.year, this.selectedDate.getMonth(), this.selectedDate.getDate());
        }
        this.setDefaultsForYearRange();
        this.generateWeekDateCalendar();
        this.calendarModel.calendarDisplay = CalendarDisplay.days;
    }
};
AbpCalendarComponent.ɵfac = function AbpCalendarComponent_Factory(t) { return new (t || AbpCalendarComponent)(ɵngcc0.ɵɵdirectiveInject(AbpCalendarConstant.calendarConfigInjectKey)); };
AbpCalendarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpCalendarComponent, selectors: [["abp-calendar"]], inputs: { selectedDate: "selectedDate" }, outputs: { selectedDateChange: "selectedDateChange" }, decls: 16, vars: 6, consts: [["id", "div_abp_calendar", "name", "div_abp_calendar", 1, "abp-calendar"], ["id", "div_abp_calendar_header", "name", "div_abp_calendar_header", 1, "abp-calendar", "header"], ["id", "div_display_section_year", "name", "div_display_section_year", 1, "section"], ["id", "btn_prev_year", "name", "btn_prev_year", "type", "button", 1, "arrow-button", 3, "click"], ["id", "span_display_year", "name", "span_display_year", 1, "month-year-display", 3, "click"], ["id", "btn_next_year", "type", "button", 1, "arrow-button", 3, "disabled", "click"], ["id", "div_display_section_month", "name", "div_display_section_month", "class", "section", 4, "ngIf"], ["id", "div_abp_calendar_body", "name", "div_abp_calendar_body", 1, "abp-calendar", "body"], ["id", "t_abp_calendar_grid", "name", "t_abp_calendar_grid", 1, "calendar-grid"], ["id", "t_abp_calendar_grid_header", "name", "t_abp_calendar_grid_header", 4, "ngIf"], ["id", "t_abp_calendar_grid_body", "name", "t_abp_calendar_grid_body"], [4, "ngIf"], ["id", "div_display_section_month", "name", "div_display_section_month", 1, "section"], ["id", "btn_prev_month", "name", "btn_prev_month", "type", "button", 1, "arrow-button", 3, "click"], ["id", "span_display_month", "name", "span_display_month", 1, "month-year-display", 3, "click"], ["id", "btn_next_month", "name", "btn_next_month", "type", "button", 1, "arrow-button", 3, "click"], ["id", "t_abp_calendar_grid_header", "name", "t_abp_calendar_grid_header"], ["id", "t_abp_calendar_grid_header_row", "name", "t_abp_calendar_grid_header_row", 1, "weekday-row"], [4, "ngFor", "ngForOf"], [1, "weekday-header-cell", 3, "id"], [3, "id", "ngClass", 4, "ngFor", "ngForOf"], [3, "id", "ngClass"], ["id", "btn_abp_calendar_grid_cell", "type", "button", 1, "cell-button", 3, "ngClass", "click"]], template: function AbpCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "h3");
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_Template_button_click_4_listener() { return ctx.onPrevYearClick(); });
        ɵngcc0.ɵɵtext(5, " < ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_Template_span_click_6_listener() { return ctx.onDisplayHeaderClick(2); });
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function AbpCalendarComponent_Template_button_click_8_listener() { return ctx.onNextYearClick(); });
        ɵngcc0.ɵɵtext(9, " > ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, AbpCalendarComponent_div_10_Template, 8, 3, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "table", 8);
        ɵngcc0.ɵɵtemplate(13, AbpCalendarComponent_thead_13_Template, 3, 1, "thead", 9);
        ɵngcc0.ɵɵelementStart(14, "tbody", 10);
        ɵngcc0.ɵɵtemplate(15, AbpCalendarComponent_ng_container_15_Template, 2, 1, "ng-container", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("disabled", ctx.calendarModel.isPrevMonthBtnDisabled ? "true" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.calendarModel.displayYearVal.year, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.calendarModel.isNextMonthBtnDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canShowSection(0));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canShowSection(0));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.calendarModel.displayGrid);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".abp-calendar[_ngcontent-%COMP%], .center-text[_ngcontent-%COMP%]{text-align:center}.abp-calendar[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%], .large-bold-font[_ngcontent-%COMP%]{font-size:large;font-weight:700}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]   .monthyear-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-header-cell[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%], .transparent-border[_ngcontent-%COMP%], .transparent-button[_ngcontent-%COMP%], .weekday-cell[_ngcontent-%COMP%]{border-style:solid;border-color:transparent}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]   .monthyear-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%]:hover, .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%]:hover, .hover-border[_ngcontent-%COMP%]{border-color:#000!important}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]   .monthyear-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%], .transparent-button[_ngcontent-%COMP%]{background-color:transparent}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%], .abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-header-cell[_ngcontent-%COMP%], .weekday-cell[_ngcontent-%COMP%]{min-width:13%!important;max-width:13%!important}.current-datepart[_ngcontent-%COMP%]{color:#1e90ff!important;border-style:solid!important;border-color:#1e90ff!important}.other-month-date[_ngcontent-%COMP%]{color:#a9a9a9!important}.selected-datepart[_ngcontent-%COMP%]{border-color:gold!important;border-style:solid!important}.abp-calendar[_ngcontent-%COMP%]{background-color:#fff;color:#000;border-style:double;min-width:300px}.abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background-color:#6495ed;color:#fff}.abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .section[_ngcontent-%COMP%]{display:inline-block;padding:2px;border:none;margin:0}.abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%]{color:#fff}.abp-calendar[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .month-year-display[_ngcontent-%COMP%]{cursor:pointer}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]{min-width:100px;width:100%;height:100%}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]{line-height:4.35;width:100%}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]   .monthyear-cell[_ngcontent-%COMP%]{width:20%;min-width:26%;max-width:20%}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .monthyear-row[_ngcontent-%COMP%]   .monthyear-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%]{width:95%;min-width:50px!important;max-width:100%!important;min-height:50px}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]{width:100%}.abp-calendar[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]   .calendar-grid[_ngcontent-%COMP%]   .weekday-row[_ngcontent-%COMP%]   .weekday-data-cell[_ngcontent-%COMP%]   .cell-button[_ngcontent-%COMP%]{min-width:75%!important;max-width:100%!important;min-height:75%}"] });
AbpCalendarComponent.ctorParameters = () => [
    { type: AbpCalendarConfigModel, decorators: [{ type: Inject, args: [AbpCalendarConstant.calendarConfigInjectKey,] }] }
];
__decorate([
    Input()
], AbpCalendarComponent.prototype, "selectedDate", void 0);
__decorate([
    Output()
], AbpCalendarComponent.prototype, "selectedDateChange", void 0);
AbpCalendarComponent = __decorate([ __param(0, Inject(AbpCalendarConstant.calendarConfigInjectKey))
], AbpCalendarComponent);

//#region angular imports
var AbpCalendarModule_1;
let AbpCalendarModule = AbpCalendarModule_1 = class AbpCalendarModule {
    static forRoot(config) {
        return {
            ngModule: AbpCalendarModule_1,
            providers: [
                { provide: AbpCalendarConstant.calendarConfigInjectKey, useValue: config },
            ],
        };
    }
};
AbpCalendarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpCalendarModule });
AbpCalendarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpCalendarModule_Factory(t) { return new (t || AbpCalendarModule)(); }, imports: [[
            CommonModule,
            RouterModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'abp-calendar',
                template: "\r\n<div id=\"div_abp_calendar\" name=\"div_abp_calendar\" class=\"abp-calendar\">\r\n  <div id=\"div_abp_calendar_header\" name=\"div_abp_calendar_header\" class=\"abp-calendar header\">\r\n    <div id=\"div_display_section_year\" name=\"div_display_section_year\" class=\"section\">\r\n      <h3>\r\n        <button id=\"btn_prev_year\"\r\n                name=\"btn_prev_year\"\r\n                type=\"button\"\r\n                class=\"arrow-button\"\r\n                (click)=\"onPrevYearClick()\"\r\n                [attr.disabled]=\"calendarModel.isPrevMonthBtnDisabled ? 'true' : null\">\r\n          <\r\n        </button>\r\n\r\n        <span id=\"span_display_year\"\r\n              name=\"span_display_year\"\r\n              class=\"month-year-display\"\r\n              (click)=\"onDisplayHeaderClick(2)\">\r\n          {{ calendarModel.displayYearVal.year }}\r\n        </span>\r\n\r\n        <button id=\"btn_next_year\"\r\n                type=\"button\"\r\n                class=\"arrow-button\"\r\n                (click)=\"onNextYearClick()\"\r\n                [disabled]=\"calendarModel.isNextMonthBtnDisabled\">\r\n          >\r\n        </button>\r\n      </h3>\r\n    </div>\r\n    <div id=\"div_display_section_month\" name=\"div_display_section_month\" class=\"section\" *ngIf=\"canShowSection(0)\">\r\n      <h3>\r\n        <button id=\"btn_prev_month\"\r\n                name=\"btn_prev_month\"\r\n                type=\"button\"\r\n                class=\"arrow-button\"\r\n                (click)=\"onPrevMonthClick()\"\r\n                [attr.disabled]=\"calendarModel.isPrevYearBtnDisabled ? 'true' : null\">\r\n          <\r\n        </button>\r\n\r\n        <span id=\"span_display_month\"\r\n              name=\"span_display_month\"\r\n              class=\"month-year-display\"\r\n              (click)=\"onDisplayHeaderClick(1)\">\r\n          {{ calendarModel.displayMonthVal.monthName }}\r\n        </span>\r\n\r\n        <button id=\"btn_next_month\"\r\n                name=\"btn_next_month\"\r\n                type=\"button\"\r\n                class=\"arrow-button\"\r\n                (click)=\"onNextMonthClick()\"\r\n                [attr.disabled]=\"calendarModel.isNextYearBtnDisabled ? 'true' : null\">\r\n          >\r\n        </button>\r\n      </h3>\r\n    </div>\r\n  </div>\r\n  <div id=\"div_abp_calendar_body\" name=\"div_abp_calendar_body\" class=\"abp-calendar body\">\r\n    <table id=\"t_abp_calendar_grid\" name=\"t_abp_calendar_grid\" class=\"calendar-grid\">\r\n      <thead id=\"t_abp_calendar_grid_header\" name=\"t_abp_calendar_grid_header\" *ngIf=\"canShowSection(0)\">\r\n        <tr id=\"t_abp_calendar_grid_header_row\" name=\"t_abp_calendar_grid_header_row\" class=\"weekday-row\">\r\n          <ng-container *ngFor=\"let name of calendarModel.weekNames; let i = index\">\r\n            <th id=\"t_abp_calendar_grid_header_cell_{{i}}\"\r\n                class=\"weekday-header-cell\">\r\n              {{name}}\r\n            </th>\r\n          </ng-container>\r\n        </tr>\r\n      </thead>\r\n      <tbody id=\"t_abp_calendar_grid_body\" name=\"t_abp_calendar_grid_body\">\r\n        <ng-container *ngIf=\"calendarModel.displayGrid\">\r\n          <tr id=\"t_abp_calendar_grid_body_row_{{i}}\"\r\n              [ngClass]=\"{'monthyear-row':!canShowSection(0), 'weekday-row':canShowSection(0)}\"\r\n              *ngFor=\"let itemArr of calendarModel.displayGrid.gridData; let i = index\">\r\n            <ng-container *ngFor=\"let item of itemArr; let j = index\">\r\n\r\n              <td id=\"t_abp_calendar_grid_body_cell_{{i}}_{{j}}\"\r\n                  [ngClass]=\"{'monthyear-cell':!canShowSection(0), 'weekday-data-cell':canShowSection(0)}\">\r\n\r\n                <button id=\"btn_abp_calendar_grid_cell\"\r\n                        type=\"button\"\r\n                        class=\"cell-button\"\r\n                        (click)=\"onGridCellClick(item)\"\r\n                        [ngClass]=\"{'current-datepart': item.isCurrentPart,'other-month-date': item.isDisabled, 'selected-datepart': item.isSelectedDatePart}\">\r\n                  {{ item.displayText }}\r\n                </button>\r\n              </td>\r\n            </ng-container>\r\n          </tr>\r\n        </ng-container>\r\n\r\n      </tbody>\r\n    </table>\r\n\r\n  </div>\r\n</div>\r\n",
                styles: [".abp-calendar,.center-text{text-align:center}.abp-calendar,.abp-calendar .header .arrow-button,.large-bold-font{font-size:large;font-weight:700}.abp-calendar .body,.abp-calendar .body .calendar-grid .monthyear-row .monthyear-cell .cell-button,.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell,.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell .cell-button,.abp-calendar .body .calendar-grid .weekday-row .weekday-header-cell,.abp-calendar .header,.abp-calendar .header .arrow-button,.transparent-border,.transparent-button,.weekday-cell{border-style:solid;border-color:transparent}.abp-calendar .body .calendar-grid .monthyear-row .monthyear-cell .cell-button:hover,.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell .cell-button:hover,.hover-border{border-color:#000!important}.abp-calendar .body .calendar-grid .monthyear-row .monthyear-cell .cell-button,.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell .cell-button,.abp-calendar .header .arrow-button,.transparent-button{background-color:transparent}.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell,.abp-calendar .body .calendar-grid .weekday-row .weekday-header-cell,.weekday-cell{min-width:13%!important;max-width:13%!important}.current-datepart{color:#1e90ff!important;border-style:solid!important;border-color:#1e90ff!important}.other-month-date{color:#a9a9a9!important}.selected-datepart{border-color:gold!important;border-style:solid!important}.abp-calendar{background-color:#fff;color:#000;border-style:double;min-width:300px}.abp-calendar .header{background-color:#6495ed;color:#fff}.abp-calendar .header .section{display:inline-block;padding:2px;border:none;margin:0}.abp-calendar .header .arrow-button{color:#fff}.abp-calendar .header .month-year-display{cursor:pointer}.abp-calendar .body .calendar-grid{min-width:100px;width:100%;height:100%}.abp-calendar .body .calendar-grid .monthyear-row{line-height:4.35;width:100%}.abp-calendar .body .calendar-grid .monthyear-row .monthyear-cell{width:20%;min-width:26%;max-width:20%}.abp-calendar .body .calendar-grid .monthyear-row .monthyear-cell .cell-button{width:95%;min-width:50px!important;max-width:100%!important;min-height:50px}.abp-calendar .body .calendar-grid .weekday-row{width:100%}.abp-calendar .body .calendar-grid .weekday-row .weekday-data-cell .cell-button{min-width:75%!important;max-width:100%!important;min-height:75%}"]
            }]
    }], function () { return [{ type: AbpCalendarConfigModel, decorators: [{
                type: Inject,
                args: [AbpCalendarConstant.calendarConfigInjectKey]
            }] }]; }, { selectedDateChange: [{
            type: Output
        }], selectedDate: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpCalendarModule, { declarations: function () { return [AbpCalendarComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [AbpCalendarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpCalendarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                ],
                declarations: [
                    AbpCalendarComponent
                ],
                exports: [
                    AbpCalendarComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of abp-calendar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbpCalendarComponent, AbpCalendarConfigModel, AbpCalendarConstant, AbpCalendarModule };

//# sourceMappingURL=colibrium-abp-calendar.js.map